<div class="bg-gray-800 text-white text-xs px-3 py-1 rounded shadow-lg max-w-xs whitespace-nowrap z-50"
     [ngClass]="tooltipClass">
  {{ text }}
</div>
